<template>
  <div class="tooltip" :style="tooltipStyle">
    <img
      v-if="copyStatus"
      src="/img/icon_copy.svg"
      alt=""
      style="margin-right: 2px"
    />
    <span v-if="type === 'status'">{{
      copyStatus
        ? "클립보드에 복사되었습니다."
        : "클릭하면 파일명을 클립보드에 저장합니다."
    }}</span>
    <span v-else>
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
    },
    text: {
      type: String,
      required: true,
    },
    position: {
      type: Object,
      default: () => ({ top: "0", left: "0" }),
    },
    copyStatus: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tooltipStyle() {
      return {
        position: "absolute",
        top: this.position.top,
        left: this.position.left,
        right: this.position.right ? this.position.right : "none",
        backgroundColor: this.copyStatus ? "#465AFA" : "#333",
      };
    },
  },
};
</script>

<style scoped>
.tooltip {
  padding: 4px 7px;
  position: absolute;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  color: #fff;
  font-weight: 400;
  transition: 0.3s;
  text-align: left;
  z-index: 10;
  line-height: 1;
  display: inline-flex;
}
.tooltip span {
  font-size: 10px !important;
}
</style>
